import { z } from 'zod';

const phoneShape = {
  phone1: z.string().regex(/^01[0-9]$/, '연락처를 확인해주세요.'),
  phone2: z.string().regex(/^\d{3,4}$/, '연락처를 확인해주세요.'),
  phone3: z.string().regex(/^\d{4}$/, '연락처를 확인해주세요.'),
};

const emailField = z.string().trim().min(1, '이메일을 입력해주세요.').email('이메일 형식이 올바르지 않습니다.');

export const loginSchema = z.object({
  email: emailField,
  password: z.string().min(1, '비밀번호를 입력해주세요.'),
});

export type LoginSchema = z.infer<typeof loginSchema>;

export const signupSchema = z
  .object({
    ...phoneShape,
    name: z.string().min(1, '이름을 입력해주세요.'),
    password: z.string().min(4, '비밀번호는 4자 이상 입력해주세요.'),
    passwordConfirm: z.string().min(1, '비밀번호 확인을 입력해주세요.'),
    email: emailField,
  })
  .refine((data) => data.password === data.passwordConfirm, {
    message: '비밀번호가 일치하지 않습니다.',
    path: ['passwordConfirm'],
  });

export type SignupSchema = z.infer<typeof signupSchema>;

// 소셜 인증 후 가입: 비밀번호 없이 이메일/이름/휴대폰번호만 받는다
export const socialSignupSchema = z.object({
  ...phoneShape,
  name: z.string().min(1, '이름을 입력해주세요.'),
  email: emailField,
});

export type SocialSignupSchema = z.infer<typeof socialSignupSchema>;

export function joinPhone(values: { phone1: string; phone2: string; phone3: string }): string {
  return `${values.phone1}${values.phone2}${values.phone3}`;
}
